import "./affiliation.css"
import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {setAffiliationField, setQuestions} from "../../../redux/affiliation_store";
import {setPersonalData} from "../../../redux/personal_store";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import ProgressBar from "react-bootstrap/ProgressBar";
import register from "../../../assets/register_img.webp";
import apiClient from "../../../utils/axios";

function AffiliationInfo({affiliation, setQuestions, setAffiliationField, appData, personalData}) {

    const {t} = useTranslation()
    const navigate = useNavigate()

    let linkTo = '/account'
    if (appData.account_type === 'custodial') linkTo = '/custodial-account'
    if (appData.account_type === 'speciality') linkTo = '/authorized-signers'
    if (appData.account_type === 'IRA') linkTo = '/account'
    const now = 40;

    const [affiliationErrors, setAffiliationErrors] = useState({
        organizations: "",
        name: "",
        memberCompanyName: "",
        memberAffPerson: "",
        memberPosition: "",
        companyName: "",
        affPerson: "",
        position: "",
        process: "",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        setAffiliationErrors({
            organizations: "",
            name: "",
            memberCompanyName: "",
            memberAffPerson: "",
            memberPosition: "",
            companyName: "",
            affPerson: "",
            position: "",
            process: "",
        });

        let isValid = true;

        const memberCompanyName = affiliation.questions.some(el => ['AffiliationMember'].includes(el.name) && el.selected)
        const affiliationBroke = affiliation.questions.some(el => ["AffiliationBroker"].includes(el.name) && el.selected)
        const affiliationForShellBank = affiliation.questions.some(el => ['AffiliationForShellBank'].includes(el.name) && el.selected)
        const affiliationPoliOfficial = affiliation.questions.some(el => ['AffiliationPoliOfficial'].includes(el.name) && el.selected)

        if (!affiliation.organizations && affiliationPoliOfficial) {
            setAffiliationErrors((prevErrors) => ({
                ...prevErrors,
                organizations: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!affiliation.name && affiliationPoliOfficial) {
            setAffiliationErrors((prevErrors) => ({
                ...prevErrors,
                name: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!affiliation.memberCompanyName && memberCompanyName) {
            setAffiliationErrors((prevErrors) => ({
                ...prevErrors,
                memberCompanyName: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!affiliation.memberAffPerson && memberCompanyName) {
            setAffiliationErrors((prevErrors) => ({
                ...prevErrors,
                memberAffPerson: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!affiliation.memberPosition && memberCompanyName) {
            setAffiliationErrors((prevErrors) => ({
                ...prevErrors,
                memberPosition: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!affiliation.companyName && affiliationBroke) {
            setAffiliationErrors((prevErrors) => ({
                ...prevErrors,
                companyName: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!affiliation.affPerson && affiliationBroke) {
            setAffiliationErrors((prevErrors) => ({
                ...prevErrors,
                affPerson: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!affiliation.position && affiliationBroke) {
            setAffiliationErrors((prevErrors) => ({
                ...prevErrors,
                position: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!affiliation.process && affiliationForShellBank) {
            setAffiliationErrors((prevErrors) => ({
                ...prevErrors,
                process: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (isValid) {
            setAffiliationField(affiliation);
            if (!appData.app_id) alert('Missing app id')

            try {
                await updateAffiliation()
                navigate(linkTo)
            } catch (error) {
                setAffiliationField((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    }

    const handleRadioChange = (questionId, value) => {
        const updatedQuestions = affiliation.questions.map((item) => {
            if (item.id === questionId) {
                return {...item, selected: value};
            }
            return item;
        });
        setQuestions(updatedQuestions);
    };

    const getAffiliationValues = (affiliation) => {
        const converter = (field) => {
            const item = affiliation.questions.find(el => el.name === field)

            return item?.selected ? 'Y' : 'N'
        }

        return {
            AffiliationMember: converter('AffiliationMember'),
            AffiliationBroker: converter('AffiliationBroker'),
            AffiliationForShellBank: converter('AffiliationForShellBank'),
            AffiliationShellBank: converter('AffiliationShellBank'),
            AffiliationShellBankService: converter('AffiliationShellBankService'),
            AffiliationBankrupt: converter('AffiliationBankrupt'),
            AffiliationLegal: converter('AffiliationLegal'),
            AffiliationUnpaid: converter('AffiliationUnpaid'),
            AffiliationOtherFunds: converter('AffiliationOtherFunds'),
            AffiliationFFI: converter('AffiliationFFI'),
            AffiliationPoliOfficial: converter('AffiliationPoliOfficial'),
            AffiliationPoliOfficialOrg: affiliation.organizations,
            AffiliationPoliOfficialName: affiliation.name,
            AffiliationMemberFirm: affiliation.memberCompanyName,
            AffiliationMemberName: affiliation.memberAffPerson,
            AffiliationMemberPosition: affiliation.memberPosition,
            AffiliationBrokerFirm: affiliation.companyName,
            AffiliationBrokerName: affiliation.affPerson,
            AffiliationBrokerPosition: affiliation.position,
            AffiliationForShellBankAgent: affiliation.process,
        };
    };

    const updateAffiliation = async () => {
        const URL = `${process.env.REACT_APP_API_URL}/api/accounts/step3/` + appData.app_id;
        const params = getAffiliationValues(affiliation);

        try {
            const response = await apiClient.put(URL, params, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            });

            if (response.data && response.data.status &&
                ['400', '401', '403', '404', '405', '408', '429', '500', '501', '502', '503', '504', '505'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }
        } catch (error) {
            throw error;
        }
    };

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setAffiliationField(name, value);
    };

    return (
        <div className="affiliation flex">
            <div className="left_side">
                <img
                    className="w-full"
                    height="auto"
                    src={register}
                    alt=""
                />
            </div>
            <div className="right_side">
                <div className="flex justify-content-between align-items-baseline">
                    <div role="progressbar" id="combo" aria-label="progress" className="w-100">
                        <ProgressBar now={now} label={`${now}%`} visuallyHidden/>
                    </div>
                    <Logout/>
                </div>

                <p className="affiliation_heading text-center font-normal uppercase text-xl">
                    {t('affiliation.welcome')} {personalData.firstName} {personalData.lastName}. {t('affiliation.affiliated')}
                </p>

                <p className="affiliation_info_heading text-center font-normal uppercase text-lg">
                    {t('affiliation.affiliation_information')}
                </p>

                <div className="affiliation_info w-full">
                    <form onSubmit={handleSubmit}>
                        {affiliation.questions.map((item, i) => {
                            return (
                                <div className="pb-5" key={i}>
                                    <p className="affiliation_question text-center font-bold text-base"> {t(item.text)}</p>
                                    <div className="flex justify-content-center gap-4">
                                        <div className="flex align-items-center gap-1">
                                            <input
                                                type="radio"
                                                className="aff_checkbox w-1rem h-1rem"
                                                name={item.id}
                                                value="yes"
                                                id={item.id}
                                                checked={item.selected === true}
                                                onChange={() => handleRadioChange(item.id, true)}
                                            />
                                            <label htmlFor={item.id}
                                                   className="aff_checkbox_text text-center font-normal text-xl">
                                                {t('affiliation.yes')}
                                            </label>
                                        </div>

                                        <div className="flex align-items-center gap-1">
                                            <input
                                                type="radio"
                                                className="aff_checkbox w-1rem h-1rem"
                                                name={item.id}
                                                value="no"
                                                id={item.id}
                                                checked={item.selected === false}
                                                onChange={() => handleRadioChange(item.id, false)}
                                            />
                                            <label htmlFor={item.id}
                                                   className="aff_checkbox_text text-center font-normal text-xl">
                                                {t('affiliation.no')}
                                            </label>
                                        </div>
                                    </div>

                                    {item.id === 1 && item.selected === true && (
                                        <div className="flex flex-column gap-3 pt-3">
                                            <div className="flex flex-wrap gap-2">
                                                <div className="aff_full_input">
                                                    <input
                                                        className="aff_inputs flex w-full align-items-center p-2 gap-4"
                                                        type="text"
                                                        placeholder={t('affiliation.aff_company_name')}
                                                        name="memberCompanyName"
                                                        value={affiliation.memberCompanyName}
                                                        onChange={handleInputChange}
                                                    />
                                                    {affiliationErrors.memberCompanyName &&
                                                        <p className="text-red-600 text-xs mt-1 mb-0 text-start">{affiliationErrors.memberCompanyName}</p>
                                                    }
                                                </div>

                                                <div className="aff_full_input">
                                                    <input
                                                        className="aff_inputs flex w-full align-items-center p-2 gap-4"
                                                        type="text"
                                                        placeholder={t('affiliation.your_position')}
                                                        value={affiliation.memberPosition}
                                                        onChange={handleInputChange}
                                                        name="memberPosition"
                                                    />
                                                    {affiliationErrors.memberPosition &&
                                                        <p className="text-red-600 text-xs mt-1 mb-0 text-start">{affiliationErrors.memberPosition}</p>
                                                    }
                                                </div>
                                            </div>

                                            <div>
                                                <input className="aff_inputs flex w-full align-items-center p-2 gap-4"
                                                       type="text"
                                                       name="memberAffPerson"
                                                       value={affiliation.memberAffPerson}
                                                       onChange={handleInputChange}
                                                       placeholder={t('affiliation.aff_person_name')}
                                                />
                                                {affiliationErrors.memberAffPerson &&
                                                    <p className="text-red-600 text-xs mt-1 mb-0 text-start">{affiliationErrors.memberAffPerson}</p>
                                                }
                                            </div>
                                        </div>
                                    )}

                                    {item.id === 2 && item.selected === true && (
                                        <div className="flex flex-column gap-3 pt-3">
                                            <div className="flex flex-wrap gap-2">
                                                <div className="aff_full_input">
                                                    <input
                                                        className="aff_inputs flex w-full align-items-center p-2 gap-4"
                                                        type="text"
                                                        placeholder={t('affiliation.aff_company_name')}
                                                        name="companyName"
                                                        value={affiliation.companyName}
                                                        onChange={handleInputChange}
                                                    />
                                                    {affiliationErrors.companyName &&
                                                        <p className="text-red-600 text-xs mt-1 mb-0 text-start">{affiliationErrors.companyName}</p>
                                                    }
                                                </div>
                                                <div className="aff_full_input">
                                                    <input
                                                        className="aff_inputs flex w-full align-items-center p-2 gap-4"
                                                        type="text"
                                                        placeholder={t('affiliation.your_position')}
                                                        name="position"
                                                        value={affiliation.position}
                                                        onChange={handleInputChange}
                                                    />
                                                    {affiliationErrors.position &&
                                                        <p className="text-red-600 text-xs mt-1 mb-0 text-start">{affiliationErrors.position}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div>
                                                <input className="aff_inputs flex w-full align-items-center p-2 gap-4"
                                                       type="text"
                                                       name="affPerson"
                                                       value={affiliation.affPerson}
                                                       onChange={handleInputChange}
                                                       placeholder={t('affiliation.aff_person_name')}
                                                />
                                                {affiliationErrors.affPerson &&
                                                    <p className="text-red-600 text-xs mt-1 mb-0 text-start">{affiliationErrors.affPerson}</p>
                                                }
                                            </div>
                                        </div>
                                    )}

                                    {item.id === 3 && item.selected === true && (
                                        <div className="pt-3">
                                            <input className="aff_inputs flex w-full align-items-center p-2 gap-4"
                                                   type="text"
                                                   name="process"
                                                   value={affiliation.process}
                                                   onChange={handleInputChange}
                                                   placeholder={t('affiliation.agent_list')}
                                            />
                                            {affiliationErrors.process &&
                                                <p className="text-red-600 text-xs mt-1 mb-0 text-start">{affiliationErrors.process}</p>
                                            }
                                        </div>
                                    )}

                                    {item.id === 10 && item.selected === true && (
                                        <div className="pt-3">
                                            <p className="text-center">{t('affiliation.financial_regulator')}</p>
                                        </div>
                                    )}

                                    {item.id === 11 && item.selected === true && (
                                        <div className="pt-3">
                                            <p className="text-center">
                                                {t('affiliation.political_organization')}
                                            </p>
                                            <div className="flex flex-wrap gap-2">
                                                <div className="aff_full_input">
                                                    <input
                                                        className="aff_inputs flex w-full align-items-center p-2 gap-4"
                                                        type="text"
                                                        placeholder={t('affiliation.name')}
                                                        name="name"
                                                        value={affiliation.name}
                                                        onChange={handleInputChange}
                                                    />
                                                    {affiliationErrors.name &&
                                                        <p className="text-red-600 text-xs mt-1 mb-0 text-start">{affiliationErrors.name}</p>
                                                    }
                                                </div>

                                                <div className="aff_full_input">
                                                    <input
                                                        className="aff_inputs flex w-full align-items-center p-2 gap-4"
                                                        type="text"
                                                        placeholder={t('affiliation.organization')}
                                                        name="organizations"
                                                        value={affiliation.organizations}
                                                        onChange={handleInputChange}
                                                    />
                                                    {affiliationErrors.organizations &&
                                                        <p className="text-red-600 text-xs mt-1 mb-0 text-start">{affiliationErrors.organizations}</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}

                        <div
                            className="flex sm:justify-content-between justify-content-center align-items-center gap-2 sm:flex-row flex-column-reverse row-gap-3 pt-6">
                            <Link className="no-underline" to="/financial">
                                <button className="back_btn">
                                    {t('back_btn')}
                                </button>
                            </Link>
                            <button className="continue_btn" type="submit">
                                {t('next_btn')}
                            </button>
                        </div>

                        <div>
                            {affiliationErrors.submitError && (
                                <div className="text-red-500 text-center">
                                    {affiliationErrors.submitError}
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    affiliation: state.affiliation,
    appData: state.appData,
    personalData: state.personalData
});

const mapDispatchToProps = {
    setQuestions,
    setAffiliationField,
    setPersonalData
};

export default connect(mapStateToProps, mapDispatchToProps)(AffiliationInfo);